module.exports = __webpack_public_path__ + "img/service-finance.a00d72a.webp";